// import components
import { Paper, PaperProps, styled } from '@mui/material';

export const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'fixedHeight'
})<PaperProps & { fixedHeight?: number }>(({ theme, fixedHeight }) => ({
  padding: theme.spacing(6),
  borderRadius: theme.shape.borderRadius,
  boxSizing: 'border-box',
  maxHeight: 'calc(100vh - 200px)',
  overflow: 'auto',
  ...(fixedHeight ? { height: `${fixedHeight}px` } : {})
}));

export const CustomStyledPaper = styled(StyledPaper, {
  shouldForwardProp: (prop) => prop !== 'finishedAllItemTasks'
})<PaperProps & { finishedAllItemTasks?: boolean }>(
  ({ theme, finishedAllItemTasks }) => ({
    position: 'relative',
    backgroundColor: finishedAllItemTasks
      ? '#FCFCF1'
      : theme.palette.common.white,
    '&:hover ': {
      boxShadow: theme.shadows[3],

      '& .tile-remove': {
        opacity: 1,
        visibility: 'visible',
        pointerEvents: 'auto'
      }
    }
  })
);

export const StyledPaperFlexColumn = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  position: 'relative'
}));

export const StyledCustomMediumDialogPaper = styled(Paper)({
  width: '540px'
});

export const StyledFilterPopperPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[8],
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  touchAction: 'none',

  '&&#filter-popper-motion-paper': {
    width: 'fit-content'
  }
}));
